var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { setCookie, getCookie } from '../../util';
var COOKIE_NAME = 'impersonation';
export function ImpersonationsContainer(_a) {
    var impersonations = _a.impersonations;
    var _b = useState(getCookie(COOKIE_NAME)), currentImpersonation = _b[0], setCurrentImpersonation = _b[1];
    // fetch current impersonation from cookies
    // update current impersonation from cookies
    function updateImpersonation(value) {
        setCookie(COOKIE_NAME, value, 1000);
        setCurrentImpersonation(value);
        location.reload();
    }
    return (_jsx(Container, { children: _jsxs("select", __assign({ value: currentImpersonation, onChange: function (event) { return updateImpersonation(event.target.value); } }, { children: [_jsx("option", __assign({ value: '' }, { children: currentImpersonation
                        ? 'CLEAR IMPERSONATION'
                        : 'SELECT IMPERSONATION' }), void 0),
                impersonations.map(function (i) { return (_jsx("option", __assign({ value: i.id }, { children: i.firstName + " " + i.lastName }), i.id)); })] }), void 0) }, void 0));
}
var Container = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: default;\n  padding: 20px 15px;\n"], ["\n  cursor: default;\n  padding: 20px 15px;\n"])));
var templateObject_1;
